module.exports = __webpack_public_path__ + "img/评估中心背景_3_1.07ce42c4.png";